export default () => ({
  positions: [0, 1, 2]
    .sort(() => Math.random() - 0.5)
    .map((zone) => ({
      top: `${zone * 27 + Math.random() * 20}%`,
      left: `${Math.random() * 70}%`,
    })),
});
